<script setup lang="ts">
// Depósitos suspensos (Medida Provisória): substitui as etapas do modal
// enquanto os depósitos estão desligados no core (ENG-915). Textos em
// utils/deposit-suspension.ts, sobrepostos pelo core; paleta igual à do
// StepDenied.
//
// `notice` é opcional: sem ele, mostra o aviso de depósito. O AnnouncementModal
// passa os textos da pausa do site pra reusar o mesmo visual.
import type { SuspensionNotice } from '~/utils/deposit-suspension';

type Props = {
  notice?: SuspensionNotice;
};

const props = defineProps<Props>();

const shown = computed(() => props.notice ?? getSuspensionNotice('deposit'));

type Emits = {
  close: [];
};

const emit = defineEmits<Emits>();
</script>

<template>
  <div class="gdm-suspended">
    <div class="gdm-suspended-badge">
      <svg
        aria-hidden="true"
        fill="none"
        height="30"
        stroke="currentColor"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="2"
        viewBox="0 0 24 24"
        width="30"
      >
        <path d="M3 22h18M6 18v-7M10 18v-7M14 18v-7M18 18v-7M12 2l8 5H4z" />
      </svg>
    </div>

    <p class="gdm-suspended-title">{{ shown.title }}</p>

    <p class="gdm-suspended-message">{{ shown.message }}</p>

    <div class="gdm-suspended-reassurance">
      <svg
        aria-hidden="true"
        class="gdm-suspended-reassurance-icon"
        fill="none"
        height="20"
        stroke="currentColor"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="2"
        viewBox="0 0 24 24"
        width="20"
      >
        <path
          d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"
        />
        <path d="m9 12 2 2 4-4" />
      </svg>
      <span>{{ shown.reassurance }}</span>
    </div>

    <button
      class="gdm-suspended-dismiss"
      type="button"
      @click="emit('close')"
    >
      {{ shown.dismissLabel }}
    </button>
  </div>
</template>

<style scoped lang="scss">
$orange: #ff3700;
$green: #22c55e;

.gdm-suspended {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  width: 100%;
  padding-top: 8px;
  font-family: 'Plus Jakarta Sans', sans-serif;
  text-align: center;
}

.gdm-suspended-badge {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 76px;
  height: 76px;
  border-radius: 9999px;
  background: rgba(255, 55, 0, 0.15);
  box-shadow: 0 0 0 8px rgba(255, 55, 0, 0.05);
  color: $orange;
}

.gdm-suspended-title {
  margin-top: 10px;
  color: #fff;
  font-size: 18px;
  font-weight: 700;
}

.gdm-suspended-message {
  color: rgba(255, 255, 255, 0.7);
  font-size: 13px;
  line-height: 20px;
}

.gdm-suspended-reassurance {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  width: 100%;
  margin-top: 4px;
  padding: 12px;
  border: 1px solid rgba(34, 197, 94, 0.3);
  border-radius: 12px;
  background: rgba(34, 197, 94, 0.1);
  color: #fff;
  font-size: 13px;
  font-weight: 500;
  line-height: 18px;
  text-align: left;
}

.gdm-suspended-reassurance-icon {
  flex-shrink: 0;
  color: $green;
}

.gdm-suspended-dismiss {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 44px;
  margin-top: 8px;
  border-radius: 12px;
  background: $orange;
  color: #fff;
  font-size: 14px;
  font-weight: 700;
  text-transform: uppercase;
  cursor: pointer;
}
</style>
